import React from 'react';
import PropTypes from 'prop-types';

const ConversionBannerLink = ({ isFixedMatches, message }) => {
  const spanClassName = isFixedMatches ? 'dib mh2' : 'dib mh2 mt2';
  const aBaseClassName =
    'link outline-0 dib tc ttu br2 lh-solid ph3-l ph2 pt2-l pt1 pb3-l pb2 bg-red futura-heavy lh-solid white nowrap';
  const aClassName = isFixedMatches ? `${aBaseClassName} pt2 f8` : `${aBaseClassName} pt1 f6`;

  return (
    <a
      href="https://www.fender.com/connect/sign-up?ref=https://www.fender.com/play/plans"
      className={aClassName}
    >
      <span className={spanClassName}>{message}</span>
    </a>
  );
};

ConversionBannerLink.propTypes = {
  isFixedMatches: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default ConversionBannerLink;
